import { GetBuyerSpendingLimitResponse } from '@iwoca/lapi-client/iwocapay';

export function formatDuration({
    duration,
    groupSameLimits = true
}: {
    duration: number;
    groupSameLimits?: boolean;
}) {
    if (groupSameLimits && (duration === 1 || duration === 3)) {
        return '30 day / 3 month';
    }

    if (duration === 1) {
        return '30 day';
    }

    return `${duration} month`;
}

export function checkHasThirtyDayAndThreeMonthLimit(
    spendingLimits?: GetBuyerSpendingLimitResponse['data']['spending_limits']
) {
    if (!spendingLimits) return false;

    return (
        spendingLimits.filter(
            (limit) =>
                limit.duration_in_months === 1 || limit.duration_in_months === 3
        ).length > 1
    );
}
